export interface WorkflowActionDefinition {
  actionKey: string;
  variableKey: string;
  variableValue: string;
  labelKey?: string | null;
}

export interface WorkflowOutgoingFlowBinding {
  actionKey: string;
  flowId: string;
}

export interface WorkflowInteractiveOperatorActionConfig {
  actions?: WorkflowActionDefinition[];
  outgoingFlowBindings?: WorkflowOutgoingFlowBinding[];
}

export interface WorkflowActionCatalogItem extends WorkflowActionDefinition {
  suggestedConditionExpression: string;
}

/** Platform standard action keys — align with WOR-7 backend `WorkflowStandardActionKeys`. */
export const WORKFLOW_STANDARD_ACTION_KEYS = {
  approve: 'approve',
  reject: 'reject',
  requestChanges: 'requestChanges',
  retry: 'retry',
  compensate: 'compensate',
  success: 'success',
  failed: 'failed'
} as const;

export type WorkflowStandardActionKey =
  (typeof WORKFLOW_STANDARD_ACTION_KEYS)[keyof typeof WORKFLOW_STANDARD_ACTION_KEYS];
